import {View, Text, StyleSheet} from 'react-native';
import {useTranslation} from 'react-i18next';
import {useCurrentTheme} from "@/theming/useCurrentTheme";
import {ThemeType} from "@/theming/baseTheme";
import {MediaGrid} from "@/components/media/media-library/MediaGrid";
import {AppDataMediaItem} from "@/data/app-data-interfaces";

interface OfferMediaSectionProps {
    mediaItems: AppDataMediaItem[];
}

export const OfferMediaSection = ({mediaItems}: OfferMediaSectionProps) => {
    const {t} = useTranslation();
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);

    if (!mediaItems || mediaItems.length === 0) {
        return null;
    }

    return (
        <View style={styles.section}>
            <Text style={styles.sectionTitle}>{t('offers.includedContent')}</Text>
            <View style={styles.mediaGridContainer}>
                <MediaGrid
                    mediaItems={mediaItems}
                    folders={[]}
                    isRefreshing={false}
                    onRefresh={() => {}} // No refresh needed
                    scrollEnabled={false}
                />
            </View>
        </View>
    );
};

const createStyles = (theme: ThemeType) => StyleSheet.create({
    section: {
        marginVertical: 20,
    },
    sectionTitle: {
        fontSize: 18,
        fontWeight: '600',
        color: theme.colors.text,
        marginBottom: 12,
    },
    mediaGridContainer: {
        marginBottom: 10,
    },
});
